"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (contextClass) {
  if (!contextClass) contextClass = Object;

  // creates a new object from a class
  function create(arg1, arg2, arg3, arg4) {

    // dirty but fast
    switch (arguments.length) {
      case 1:
        return new this(arg1);
      case 2:
        return new this(arg1, arg2);
      case 3:
        return new this(arg1, arg2, arg3);
      case 4:
        return new this(arg1, arg2, arg3, arg4);
    }

    // handle edge here.
    // TODO - make this faster.
    return createFromContext.apply(this, arguments);
  }

  // creates an object from *any* native class
  function createFromContext() {
    var context = new contextClass();
    context.__proto__ = this.prototype;
    this.apply(context, arguments);
    return context;
  }

  function createAndCopyToContext() {
    var context = new contextClass();
    for (var k in this.prototype) {
      context[k] = this.prototype[k];
    }this.apply(context, arguments);
    return context;
  }

  // context class Object? Use the faster method instead.
  return contextClass === Object ? create : contextClass === Array ? createAndCopyToContext : createFromContext;
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/class/create-factory.js
 ** module id = 382
 ** module chunks = 0
 **/